__turbopack_context__.v({
  "table": "Dx5_MW_table",
  "td": "Dx5_MW_td",
});
